__turbopack_context__.v({
  "btn": "rEoABW_btn",
  "btnFooter": "rEoABW_btnFooter",
  "cards": "rEoABW_cards",
  "container": "rEoABW_container",
  "containerCard": "rEoABW_containerCard",
  "h3Platform": "rEoABW_h3Platform",
  "image": "rEoABW_image",
  "imageContainer": "rEoABW_imageContainer",
  "pPlatform": "rEoABW_pPlatform",
  "paragraph": "rEoABW_paragraph",
  "rowEtc": "rEoABW_rowEtc",
  "textCategory": "rEoABW_textCategory",
  "textH2": "rEoABW_textH2",
  "title": "rEoABW_title",
});
